module.exports = __webpack_public_path__ + "img/10.42a0f1d3.webp";